import { JWT_SET } from "./AuthActions.js";
import update from "immutability-helper";
import { parseToken } from "./AuthFilters";

let loadedToken = null;
try{
    if(parseToken( localStorage.getItem("AuthData")).valid){
        loadedToken = localStorage.getItem("AuthData");
    }
}catch(e){
    localStorage.removeItem("AuthData");
}
const initialState = {
    "session": loadedToken,
    "claims": null
};
export default function AuthReducer(state = initialState, action){
    if(action.type == JWT_SET){
        return update(state, { [action.key]: { $set: action.token } } );
    }
    return state;
}